import { Button, ButtonVariant } from '@sas/nova-commons/components/Button';
import { Divider } from '@sas/nova-commons/components/Divider';
import { Flow } from '@sas/nova-commons/components/Layouts/Flow';
import { Location } from '@sas/react-svg';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ObjectSearchState } from '../../../../store/objectSearch/ObjectSearchState';
import { selectObjectSearchState } from '../../../../store/selectors';
import { PanelHeader } from '../components/PanelHeader';
import { renderInlineCssVars, useDesignTokens } from '@sas/nova-commons/theme';
import { useI18n } from '../../../../locale/I18nContext';
import { PanelListItem } from '../components/PanelListItem';
import { createUseHtmlId } from '@sas/nova-commons/hooks/useHtmlId';
// eslint-disable-next-line no-restricted-imports
import { getListDesignTokens } from '@sas/nova-commons/components/List/__internal__/BaseList';
import cn from './SearchResultPanel.css.json';
import './SearchResultPanel.css';
const useSearchResultPanelId = createUseHtmlId('SearchResultPanel');
export const SearchResultPanelBase = (props) => {
    const dt = useDesignTokens();
    const localize = useI18n();
    const spacingTokens = renderInlineCssVars({ 'spacing-m': dt.tokens['space-base-m'] }, 'searchResult');
    const headingId = useSearchResultPanelId();
    return (React.createElement("section", { className: cn.container, style: spacingTokens, tabIndex: -1, "aria-labelledby": headingId },
        React.createElement(PanelHeader, { id: props.id, headingId: headingId, text: localize({ key: 'SearchResultPanel.title.txt' }), menuSections: [
                { items: [{ text: localize({ key: 'SearchResultPanel.menu.delete.txt' }) }] },
            ], onMenuItemSelected: () => props.actions.notifyDeleteSearchResults(props.id, [props.searchIndex]), type: 'result' }),
        React.createElement("div", { className: cn.contentContainer },
            React.createElement("div", { className: cn.body, style: getListDesignTokens(dt) },
                React.createElement(PanelListItem, { className: cn.item, item: props.searchResult, counter: props.searchIndex + 1 })),
            React.createElement(Divider, { variant: "standard" }),
            React.createElement(Flow, { className: cn.footer, orientation: "horizontal" },
                React.createElement(Flow, { orientation: "horizontal", spacing: "xxs", role: "group", className: cn.footerToolbar },
                    React.createElement(Button, { className: cn.footerToolbarButton, variant: ButtonVariant.Light, text: localize({ key: 'SearchResultPanel.convert.txt' }), icon: { icon: Location }, onPress: () => {
                            props.actions.notifyConvertSearchResults(props.id, [props.searchIndex]);
                        }, tooltip: localize({
                            key: 'SearchResultPanel.convert.tooltip.txt',
                        }) }))))));
};
export const SearchResultPanel = connect((state, props) => {
    var _a;
    const { searchResults } = (_a = selectObjectSearchState(state, props.id)) !== null && _a !== void 0 ? _a : {};
    const searchResult = searchResults === null || searchResults === void 0 ? void 0 : searchResults[props.searchIndex];
    if (!searchResult) {
        throw new Error(`Search result not found`);
    }
    return { searchResult };
}, (dispatch) => ({
    actions: bindActionCreators(ObjectSearchState.actions, dispatch),
}))(SearchResultPanelBase);
